import { render, staticRenderFns } from "./UsersAdmin.vue?vue&type=template&id=51ae65ae&scoped=true&"
import script from "./UsersAdmin.vue?vue&type=script&lang=ts&"
export * from "./UsersAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ae65ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51ae65ae')) {
      api.createRecord('51ae65ae', component.options)
    } else {
      api.reload('51ae65ae', component.options)
    }
    module.hot.accept("./UsersAdmin.vue?vue&type=template&id=51ae65ae&scoped=true&", function () {
      api.rerender('51ae65ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/users/UsersAdmin.vue"
export default component.exports